import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const showReportDocumentButton: boolean = getFeature('show-document-report-button');
